import styled from 'styled-components'

export const SheetPdf = styled.div`
  min-height: 1070px;
  width: 755px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  background-color: #ffffff;
  /* border: 1px solid black; */
  page-break-inside: auto;

  header {
    width: 100%;
    height: 60px;
    /* margin-top: -20px; */
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    background-color: #000000;
  }

  .title-white {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
  }

  tr {
    page-break-inside: avoid;
  }

  table {
    border-spacing: 0;
  }

  td {
    border: 0.5px solid #aaaaaa;
    background-color: #f9f9f9f9;
    padding: 3px 7px;
    font-size: 8px;
    font-weight: 400;
    text-align: center;
    color: #000000;
  }

  .yellow-header {
    border: 1px solid #2b2b2b;
    background-color: #ffbd00;
    padding: 5px 9px;
    font-size: 8px;
    font-weight: 700;
    line-height: 9.68px;
    text-align: center;
    color: #ffffff;
  }

  .black-header {
    border: 1px solid #aaaaaa;
    background-color: #000000;
    padding: 5px 9px;
    font-size: 8px;
    font-weight: 700;
    line-height: 9.68px;
    text-align: center;
    color: #ffffff;
  }
`
